module.exports = __webpack_public_path__ + "html/availability-form.template.html";